"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = [".error-card[_ngcontent-%COMP%]{min-width:120px;max-width:300px;margin:20px auto;color:red;font-size:20px}\n/*# sourceMappingURL=warning-sheet.component.css.map*/"];
exports.styles = styles;
